export default "__VITE_PUBLIC_ASSET__6576bd94__"